var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    d: "M6.25 25c8.333 0 27.083-4.167 35.417-18.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    d: "M33.333 6.25h8.334l2.083 8.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    d: "M12.5 43.75H6.25v-8.333h6.25zm16.667-12.5h-6.25v12.5h6.25zm16.666-8.333h-6.25V43.75h6.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.6d5c8a893bd26850a5bf3c5d258b752b.svg";
export { ForwardRef as ReactComponent };